import { placeDirectionsUrl } from "../lib/format.ts";
import type { Place } from "@shared/schema.ts";

export function DriverCard({ place }: { place: Place }) {
  const href = placeDirectionsUrl(place);
  return (
    <section className="driver-card">
      <p className="kicker">For the driver</p>
      <h1 className="serif">{place.name}</h1>
      {place.thaiName ? <p lang="th" style={{ fontSize: "1.4rem" }}>{place.thaiName}</p> : null}
      <p>{place.address ?? "Address not on the booking yet."}</p>
      {place.address || place.mapsUrl || place.coordinates?.verified ? (
        <a className="btn" href={href} data-place-nav={place.id} target="_blank" rel="noreferrer">
          Directions
        </a>
      ) : null}
    </section>
  );
}
